module.exports = __webpack_public_path__ + "images/emoji/innocent.ba98baa521e6f8f62686.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/innocent.png
// module id = g6vh
// module chunks = 1